module.exports = __webpack_public_path__ + "static/media/favicon-dev.4277db2c.ico";